<template>
  <div class="mb-3">
    <custom-callout
      :border-color="data.status.color"
      controlled
      has-toggle
      :opened="data.opened"
    >
      <div class="row py-2 mr-md-0 n-ml">
        <div class="col-12 col-md-6 text-start">
          <div>
            <span class="font-16 text-muted">
              No. de Cuestionario:
            </span>
          </div>
          <div>
            <span class="font-16 color-black ">
              {{ data.number | empty }}
            </span>
          </div>
        </div>

        <div class="col-12 col-md-4 custom-pl">
          <div class="d-flex flex-column">
            <span class="color-gray-6 d-block font-14">
              Nombre del Cuestionario:
            </span>
            <span class="font-16 color-black ">
              {{ data.questionnaireType.name | empty }}
            </span>
          </div>
        </div>
        <div
          v-if="!isReadOnly"
          class="col-12 col-md-2 custom-pl d-flex align-items-center justify-content-md-end"
        >
          <div class="d-flex align-items-center justify-content-md-end h-100">
            <check-box
              class="row-check"
              :value="data.checked"
              @input="onToggle"
            />
          </div>
        </div>
      </div>
      <template #edition>
        <div class="p-2 bg-gray">
          <div class="p-3 bg-white">
            <question-form
              :id="data.id"
              :header="{
                visible: true,
                title: 'Cuestionario de Propuesta',
                iconClass: 'fas fa-file mr-3 my-2 text-orange',
              }"
              is-preview
              is-read-only
            />
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
//libs components
import CustomCallout from 'custom-callout';
import CheckBox from 'CheckBox';
import QuestionForm from '../../questionConfig/subViews/preview/components/QuestionForm.vue';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

export default {
  name: 'ProposalQuestionnaireResult',
  components: {
    CustomCallout,
    CheckBox,
    QuestionForm,
  },
  mixins: [alertMixin],
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  methods: {
    onToggle(checked) {
      this.$emit('toggle', { id: checked ? this.data.id : null });
    },
  },
};
</script>
<style lang="css" scoped></style>
